var _templateObject = _taggedTemplateLiteralLoose(['\n  & div.input-range__track--active, div.input-range__slider {\n    border: 1px solid ', ';\n    background: ', ';\n  }\n'], ['\n  & div.input-range__track--active, div.input-range__slider {\n    border: 1px solid ', ';\n    background: ', ';\n  }\n']);
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}
import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import InputRange from 'react-input-range';
import 'react-input-range/lib/css/index.css';
import Theme from '../../Theme';
var InputRangeStyled = styled.div(_templateObject, Theme.colors.lightBlue, Theme.colors.lightBlue);
var SalaryRange = function SalaryRange(_ref) {
  var min = _ref.min,
    max = _ref.max,
    value = _ref.value,
    step = _ref.step,
    _onChange = _ref.onChange;
  var _useState = useState(value),
    range = _useState[0],
    setRange = _useState[1];
  return React.createElement(InputRangeStyled, null, React.createElement(InputRange, {
    formatLabel: function formatLabel(value) {
      return '$ ' + value;
    },
    minValue: min,
    maxValue: max,
    value: range,
    step: step,
    onChange: function onChange(value) {
      setRange(value);
      _onChange(value);
    }
  }));
};
SalaryRange.displayName = 'SalaryRange';
SalaryRange.propTypes = process.env.NODE_ENV !== "production" ? {
  min: PropTypes.number,
  max: PropTypes.number,
  value: PropTypes.oneOf([PropTypes.objectOf({
    min: PropTypes.number,
    max: PropTypes.number
  }), PropTypes.number]),
  step: PropTypes.number,
  onChange: PropTypes.func
} : {};
export default SalaryRange;